var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "lexbox-redirect-container" },
    [
      _c(_setup.HeaderComponent),
      _c(
        "section",
        { staticClass: "lexbox-redirect-section" },
        [
          _c(_setup.PromptDialogComponent, {
            attrs: {
              width: 753,
              title: _setup.texts.dialogTitle,
              subTitle: _setup.texts.dialogSubTitle,
              isOpened: _setup.showDialog,
              formSchema: _setup.nifSchema,
              context: "sso-payments",
              formFieldValues: _setup.formFieldValues,
              texts: _setup.texts.buttons,
            },
            on: { "execute-action": _setup.executeDialogAction },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }